<template>
  <div class="web-box-all">
    <ext-header ref="ExtHeader" select_menu="3"></ext-header>

    <div class="web-home-main">

      <div class="web-order-box">
        <div class="web-order-left">
          <ext-nav></ext-nav>
        </div>
        <div class="web-order-right">

          <div class="web-user-title">
            <p><i></i>我的弗兰卡 > 我的收藏</p>
          </div>

          <ext-loading v-if="list_data.length==0" style="width:100%;" title="当前没有消息"></ext-loading>

          <div class="web-home-goods">

            <div v-for="(vo,index) in list_data" :key="index" :class="[vo.select==1 ? 'web-home-goods-list active' : 'web-home-goods-list']" v-on:mouseover="changeActive(index,'list_data')" v-on:mouseout="removeActive(index,'list_data')">
              <a @click="get_goods_show(vo.goods_no)">
                <div :class="[vo.select==1 ? 'web-home-goods-list-data active' : 'web-home-goods-list-data']">
                  <img src="@/assets/goods_load.png" v-real-img="web_url+vo.goods_image">
                  <h2>{{vo.goods_name}}</h2>
                  <h3>{{vo.goods_no}}</h3>
                  <p>
                    <i>¥</i><b>{{vo.goods_money}}</b>
                  </p>
                </div>
              </a>
              <h4>
                <b class="del" @click="goods_del(index)">-</b>
                <b class="num">
                  <input type="number" v-model.number="vo.qty" oninput="if(value.length>3)value=value.slice(0,3)" />
                </b>
                <b class="add" @click="goods_add(index)">+</b>
                <b class="cart" @click="add_cart(index,vo.goods_no)">加入购物车</b>
              </h4>
            </div>

          </div>

          <div class="web-order-list-page">
            <b-pagination
              v-model="currentPage"
              :total-rows="list_count"
              :per-page="perPage"
              @change="load_page"
              first-number
              last-number
            >
            <template #prev-text><span class="lemon-page">上一页</span></template>
            <template #next-text><span class="lemon-page">下一页</span></template>
            <template #page="{ page, active }">
              <b class="lemon-page-now" v-if="active">{{ page }}</b>
              <i class="lemon-page-line" v-else>{{ page }}</i>
            </template>
            </b-pagination>
            <div class="web-page-button">
              <a @click="$bvModal.show(modal_id)">清空数据</a>
            </div>
          </div>

        </div>
      </div>

    </div>

    <div class="web-home-line"></div>

    <ext-footer ref="ExtFooter"></ext-footer>

    <ext-toast :style="toast_state" :toast_text="toast_text"></ext-toast>

    <b-modal :id="modal_id" centered  hide-footer>
      <template #modal-title>
        提示
      </template>
      <div class="d-block text-center">
        <h6>确认清空数据吗？</h6>
      </div>
      <div class="web-modal-foot">
        <a @click="$bvModal.hide(modal_id)" class="no">取消</a>
        <a @click="$bvModal.hide(modal_id);delete_data()" class="ok">确定</a>
      </div>
    </b-modal>

  </div>
</template>
<script>
import ExtHeader from '@/components/header/index'
import ExtFooter from '@/components/footer/index'
import ExtNav from '@/components/leftnav/index'
import ExtLoading from '@/components/loading/index'
import {getUserId, ajax, Encrypt, Decrypt, webUrl} from '@/utils/extend'
import Toast from '@/components/toast/index'

export default {
  name: 'collect',
  components: {
    'ext-header': ExtHeader,
    'ext-footer': ExtFooter,
    'ext-nav': ExtNav,
    'ext-loading': ExtLoading,
    'ext-toast': Toast

  },
  data () {
    return {
      title: '收藏列表',
      web_url: webUrl(),
      modal_id: 'modal_id_1',
      perPage: 9,
      currentPage: 1,
      list_data: [],
      list_count: 0,
      toast_state: 'display:none',
      toast_text: ''
    }
  },
  mounted () {
    this.load_data()

    this.modal_id = 'modal_id_' + (new Date()).valueOf()
  },
  methods: {
    toast (msg) {
      var that = this
      that.toast_state = 'display:block'
      that.toast_text = msg
      setTimeout(function () {
        that.toast_text = ''
        that.toast_state = 'display:none'
      }, 3000)
    },
    delete_data () {
      var that = this
      ajax({
        url: '/store/goods/user_goods_collect_del',
        method: 'post',
        data: {
          uid: getUserId(),
          user_id: getUserId()
        }
      }, function (ret) {
        that.load_data()
      })
    },
    get_goods_show (goodsNo) {
      this.$router.push({path: '/goods/goods_show', query: {v: Encrypt(goodsNo)}})
    },
    changeActive (index, list) {
      this.$set(this['' + list][index], 'select', '1')
    },
    removeActive (index, list) {
      this.$set(this['' + list][index], 'select', '0')
    },
    goods_add (index) {
      var listdata = this.list_data
      var qty = listdata[index].qty ? listdata[index].qty : 1
      if (qty < 999) {
        qty = qty + 1
      } else {
        qty = 999
      }
      this.$set(this.list_data[index], 'qty', qty)
    },
    goods_del (index) {
      var listdata = this.list_data
      var qty = listdata[index].qty ? listdata[index].qty : 1
      if (qty > 1) {
        qty = qty - 1
      } else {
        qty = 1
      }
      this.$set(this.list_data[index], 'qty', qty)
    },
    add_cart (index, goodsNo) {
      var that = this
      var listdata = this.list_data
      var qty = listdata[index].qty ? listdata[index].qty : 1

      ajax({
        url: '/store/order/add_cart',
        method: 'post',
        data: {
          uid: getUserId(),
          type_id: 1,
          type_add: 'add',
          goods_no: goodsNo,
          qty: qty
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.toast(ret.msg)
          that.$refs.ExtHeader.load_cart_list()
          that.$refs.ExtFooter.get_cart_count()
        } else {
          that.toast(ret.msg)
        }
      })
    },
    load_page (page) {
      this.currentPage = page
      this.load_data()
    },
    load_data () {
      var that = this
      var page = this.currentPage
      ajax({
        url: '/store/goods/user_goods_collect',
        method: 'post',
        data: {
          uid: getUserId(),
          type: 'web',
          page: page
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.list_count = ret.data.list_count

          var goodsList = ret.data.list_data
          var ListArr = []

          goodsList.forEach(function (val) {
            ListArr.push({
              'qty': 1,
              'goods_no': val.goods_no,
              'goods_name': val.goods_name,
              'goods_remark': val.goods_remark,
              'goods_image': val.goods_image,
              'goods_money': val.goods_money
            })
          })

          that.list_data = ListArr
        } else {
          that.list_data = []
          that.list_count = 0
        }
      })
    }
  }
}
</script>
<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    font-family: "Noto Sans SC";
    display: inline-flex;
}

a { text-decoration:none; }
input { box-sizing:border-box;outline:none;}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {-webkit-appearance: none;}
input[type='number'] {-moz-appearance: textfield;}

.web-box-all { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-main { width:1000px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-line { width:100%; height:70px; }

.web-order-box { width:100%; height:auto; flex-flow:row; align-content:flex-start; margin-top:20px;}
  .web-order-left { width:200px; height:auto; margin-right:15px; flex-wrap:wrap; align-content:flex-start;}

  .web-order-right { width:785px; height:auto; flex-wrap:wrap; align-content:flex-start;}

    .web-user-title { width:100%; height:40px;flex-flow:row; align-content:flex-start;}
      .web-user-title p { width:auto; height:40px; position: relative; padding:0px 20px; line-height:40px; font-size:14px; color:#333333;}
      .web-user-title p i { width:2px; height:20px; float: left; background: #d81e06; position: absolute; top:10px; left:10px;}

.web-home-goods { width:100%; height:auto; margin-top:10px; display: flex; flex-flow:row; align-content:flex-start; flex-wrap:wrap;}
  .web-home-goods-list { width:255px; height:410px; position: relative; margin:5px 0px; padding:10px; border:1px solid #ffffff;}
  .web-home-goods-list.active { border:1px solid #d81e06;}
  .web-home-goods-list-data { width:233px; height:390px; cursor: pointer; border:1px solid #e7e7e7; flex-wrap:wrap; align-content:flex-start;}
  .web-home-goods-list-data.active { border:1px solid #ffffff;}
  .web-home-goods-list-data img { width:100%; height:230px; padding:10px 10px 0px 10px; object-fit: cover;}
  .web-home-goods-list-data h2 { width:223px; height:40px; display:-webkit-box;text-overflow:ellipsis; overflow:hidden; -webkit-line-clamp: 2; -webkit-box-orient:vertical; line-height:20px; margin:5px 0px; font-size:14px; color:#333333; padding:0px 10px;}
  .web-home-goods-list-data h3 { width:233px; height:20px; line-height:20px; margin:0px; font-size:12px; color:#333333; padding:0px 10px;}
  .web-home-goods-list-data p { width:233px; height:40px; padding:0px 10px; margin:0px; flex-flow:row; align-content:flex-start;}
  .web-home-goods-list-data p i { font-size:12px; margin-right:5px; font-style:normal; color:#d81e06;}
  .web-home-goods-list-data p b { font-size:22px; color:#d81e06;}
  .web-home-goods-list h4 { width:233px; height:40px; position: absolute; left:15px; bottom: 10px; z-index: 99; margin:0px; padding:0px 10px; flex-flow:row; align-content:flex-start;}
  .web-home-goods-list h4 b { font-size:14px; line-height:30px; float:left; font-weight: normal;}
  .web-home-goods-list h4 b.del { width:30px; height:30px; cursor: pointer; line-height:25px; text-align: center; color:#666666; font-size:20px; border:1px solid #e7e7e7;}
  .web-home-goods-list h4 b.num { width:44px; height:30px; overflow: hidden; border-top:1px solid #e7e7e7; border-bottom:1px solid #e7e7e7;}
  .web-home-goods-list h4 b.num input { width:44px; height:20px; margin-top:5px; text-align: center; line-height:20px; font-size:12px; color:#333333; min-height:20px; border:0px;}
  .web-home-goods-list h4 b.add { width:30px; height:30px; cursor: pointer; line-height:25px; text-align: center; color:#666666; font-size:20px; border:1px solid #e7e7e7;}
  .web-home-goods-list h4 b.cart { width:90px; height:30px; cursor: pointer; margin-left:8px; text-align: center; line-height:30px; background: #d81e06; font-size:13px; color:#ffffff;}

.web-order-list-page { width:100%; height:40px; margin-top:20px;}

</style>
<style>
  .lemon-page { color:#333333; font-size:12px; height:24px; line-height:24px;}
  .lemon-page-now { background: #d81e06 !important; color:#ffffff !important; width:24px; height:24px;}
  .lemon-page-line { color:#333333; font-style: normal;}
  .page-item.active .page-link { border:1px solid #d81e06;background: #d81e06 !important; color:#ffffff !important;}
  .web-page-button { width:100px; height:40px; margin-left:15px;}
    .web-page-button  a { width:100px; height:40px; line-height:40px; font-size:14px; cursor: pointer; font-weight: bold; color:#333333; text-align: center;}

</style>



// WEBPACK FOOTER //
// src/pages/store/collect.vue